import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 282A591C-4D91-4AAF-B401-00F3AE4B73F2
 * name library-shelves
 * version: 3.0.39
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/library-shelves.svg
 * tags
 */
export const LibraryShelvesIcon = createSvgIcon(<><path d="M19.5,9V1.5H16.5V9H13.5V1.5H10.5V9H7.5V1.5H4.65V9H3V10.5H21V9H19.5M19.5,13.5H16.5V21H13.5V13.5H10.5V21H7.5V13.5H4.65V21H3V22.5H21V21H19.5V13.5Z" /></>, 'LibraryShelvesIcon');
export default LibraryShelvesIcon